import { render, staticRenderFns } from "./NAPSI.vue?vue&type=template&id=1c2c1682&"
import script from "./NAPSI.vue?vue&type=script&lang=js&"
export * from "./NAPSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports